/**
 * Configuration Contact TPCO — source unique de vérité pour :
 *  - Le numéro de téléphone affiché ("+221 78 585 87 87")
 *  - Le numéro WhatsApp (format international sans espaces "221785858787")
 *
 * Ces valeurs viennent des variables d'environnement (`frontend/.env`) :
 *   REACT_APP_CONTACT_PHONE
 *   REACT_APP_WHATSAPP_NUMBER
 *
 * Pour changer les numéros partout dans l'app, il suffit de modifier ces
 * variables dans `frontend/.env` puis de rebuild le frontend :
 *   docker compose build --no-cache tpco_frontend
 *   docker compose up -d tpco_frontend
 */

// Fallback : le numéro actuel (au cas où l'env var manque).
const FALLBACK_PHONE = "+221 78 585 87 87";
const FALLBACK_WA = "221785858787";

export const CONTACT_PHONE = (process.env.REACT_APP_CONTACT_PHONE || FALLBACK_PHONE).trim();
export const WHATSAPP_NUMBER = (process.env.REACT_APP_WHATSAPP_NUMBER || FALLBACK_WA).replace(/\D/g, "") || FALLBACK_WA;

/** Formats un lien WhatsApp avec un message pré-rempli optionnel. */
export const waLink = (text = "") =>
  `https://wa.me/${WHATSAPP_NUMBER}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

/** Formats un lien tel: pour appel direct. */
export const telLink = () => `tel:${CONTACT_PHONE.replace(/\s/g, "")}`;
